module.exports = __webpack_public_path__ + "img/ânâôâMâôâOârâïîÜÉ¦.e439c2da.webp";